/**
 * Bitcrusher - Effet de réduction de bits + downsampling
 * Son lo-fi, 8-bit, retro
 */

import * as Tone from 'tone';

export class Bitcrusher {
    constructor() {
        // Gain d'entrée pour booster le signal avant crushing
        this._inputGain = new Tone.Gain(2);

        this.crusher = new Tone.BitCrusher({
            bits: 8,
            wet: 1
        });

        // Limiter pour éviter le clipping post-crush
        this._limiter = new Tone.Limiter(-1);

        this._inputGain.connect(this.crusher);
        this.crusher.connect(this._limiter);

        this.input = this._inputGain;

        this._bits = 8;
        this._mix = 0.3;
        this._isActive = true;

        this._outputGain = new Tone.Gain(this._mix);
        this._limiter.connect(this._outputGain);
        this.output = this._outputGain;
    }

    get bits() { return this._bits; }
    get mix() { return this._mix; }

    setBits(bits) {
        // Minimum 2 bits (1 bit peut causer du silence)
        this._bits = Math.max(2, Math.min(16, Math.round(bits)));
        this.crusher.bits.value = this._bits;
    }

    setMix(mix) {
        this._mix = mix;
        this._outputGain.gain.value = mix;
    }

    connectTo(destination) {
        this.output.connect(destination);
    }

    /**
     * Active/désactive l'effet (économie CPU)
     * @param {boolean} active - true pour activer, false pour désactiver
     */
    setActive(active) {
        if (active === this._isActive) return;
        this._isActive = active;
        this._outputGain.gain.value = active ? this._mix : 0;
    }

    getParams() {
        return {
            bits: this._bits,
            mix: this._mix
        };
    }

    setParams(params) {
        if (params.bits !== undefined) this.setBits(params.bits);
        if (params.mix !== undefined) this.setMix(params.mix);
    }

    dispose() {
        this._inputGain.dispose();
        this.crusher.dispose();
        this._limiter.dispose();
        this._outputGain.dispose();
    }
}
